import { Box, ButtonProps, CircularProgress } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import ShowAt from "../../../../../../../../../components/common/ShowAt/ShowAt.tsx";
import { useAppStore } from "../../../../../../../../../hooks/useStores.tsx";
import Icons from "../../../../../../../../components/Icons";
import { BackgroundOption, BackgroundOptionsEnum } from "../../../index.ts";
import styles from "./BriaSwitchTab.module.scss";

interface IProps {
	items: BackgroundOption[];
}

const BriaSwitchTab = ({ items }: IProps & ButtonProps) => {
	const { imagesStore } = useAppStore();
	const [currentGenerationOption, setCurrentGenerationOption] = useState<BackgroundOptionsEnum | null>(
		BackgroundOptionsEnum.EXPAND_BACKGROUND,
	);

	const handleClick = (title: BackgroundOptionsEnum) => {
		if (!imagesStore.isGeneratingImages) {
			setCurrentGenerationOption(title);
		}
		imagesStore.handleSmartImageChange("backgroundOption", title);
	};

	return (
		<Box className={styles.container}>
			{items.map((item: BackgroundOption) => (
				<Box
					key={item.title}
					className={clsx({
						[styles.item]: true,
						[styles.selected]: item.title === imagesStore.smartImageForm.backgroundOption,
					})}
					onClick={() => handleClick(item.title)}
				>
					{((item.title === currentGenerationOption && imagesStore.isGeneratingImages) ||
						imagesStore.isUploadingSmartImageMainObject) && (
						<>
							<Box className={styles.blurLayer} />
							<CircularProgress size={24} className={styles.loader} />
						</>
					)}
					<Box className={styles.icons}>
						<ShowAt condition={item.title === imagesStore.smartImageForm.backgroundOption}>
							<Icons.Select size={13} />
						</ShowAt>

						<ShowAt condition={item.title !== imagesStore.smartImageForm.backgroundOption}>
							<Icons.Unselect size={13} />
						</ShowAt>
					</Box>

					<img src={item.imageUrl} className={styles.trash} alt={`${item.title}`} />
					<Box className={styles.title}>{item.title}</Box>
				</Box>
			))}
		</Box>
	);
};

const ObservedComponent = observer(BriaSwitchTab);
export default ObservedComponent;
